import React from "react";
import {formatReferenceCopy} from 'utils/typography';
import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";

import {COLORS} from "../../../../../../../../../config/constants";
import { ReceiptLong } from "@vedmarket/ui-kit";
import {numberWithSpaces} from "../../../../../../../../../utils/helpers";

import './invoice-title.scss';

type Props = {
    invoice?: InvoiceParamsOutput,
    index: number
}

const InvoiceTitle = ({invoice, index} : Props) => {

  const { t } = useTranslation();

  const invoiceId = invoice?.id;

  return (
    <div className='bank-invoice-title'>
      <div className='bank-invoice-title__left'>
        <ReceiptLong color={invoiceId ? COLORS.GREEN : COLORS.SLIGHTLY_GRAY} className='bank-invoice-title__icon'/>
        <Typography variant='h6' sx={{
          color: COLORS.BLACK_DARK,
          fontSize: '20px',
          fontWeight: 700,
          lineHeight: '26px',
          letterSpacing: 0,
          overflowWrap: 'break-word',
        }}>
          {formatReferenceCopy(`${index + 1}. ${t('common__text__invoice')} № ${invoice?.invoice_num}`)}
        </Typography>
      </div>
      {invoiceId && (
        <div className='bank-invoice-title__right'>
          <Typography variant='h6' sx={{
            color: COLORS.BLACK_DARK,
            fontSize: '20px',
            fontWeight: 400,
            lineHeight: '26px',
            letterSpacing: 0,
          }}>
            {numberWithSpaces(invoice?.price_total)} USD
          </Typography>
        </div>
      )}
    </div>
  )
}

export default InvoiceTitle
